<template>
  <v-container fluid grid-list-md style="padding: 20px">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="
            carregaTerminals(empresaSelecionada);
            carregaLojistas(empresaSelecionada);
          "
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px">
              <v-toolbar-title class="textoUser">Terminals</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Procurar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoTerminals = true" tile color="#3BA8A2">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom v-if="user.tipo === 'ADMIN'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B"
                    >mdi-pencil</v-icon
                  >
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="user.tipo === 'ADMIN'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000"
                    >mdi-delete</v-icon
                  >
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <p style="margin: 0px">
              <v-icon :color="item.ativo == true ? 'success' : 'error'"
                >mdi-circle</v-icon
              >
            </p>
          </template>
          <template v-slot:no-data>
            <v-row>
              <v-col>
                <v-alert
                  dark
                  dense
                  text
                  outlined
                  color="warning"
                  icon="info"
                  style="margin: 0px"
                  >Nenhum terminal cadastrado</v-alert
                >
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoTerminals" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-subtitle>* indica preenchimento obrigatório</v-card-subtitle>
        <v-card-text style="padding-bottom: 0px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Nome*"
                outlined
                dense
                hide-details
                v-model="editedItem.nome"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="EnderecoMac*"
                outlined
                dense
                hide-details
                v-model="editedItem.enderecoMac"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Tipo*"
                outlined
                dense
                hide-details
                v-model="editedItem.tipo"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-select
                label="Lojista*"
                outlined
                dense
                hide-details
                v-model="editedItem.lojistaId"
                :items="lojistas"
                item-text="nome"
                item-value="id"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6">
              <v-text-field
                label="IpImpressora*"
                outlined
                dense
                hide-details
                v-model="editedItem.ipImpressora"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6">
              <v-text-field
                label="PortalImpressora*"
                outlined
                dense
                hide-details
                v-model="editedItem.portaImpressora"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6">
              <v-text-field
                label="Orientacao*"
                outlined
                dense
                hide-details
                v-model="editedItem.orientacao"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6">
              <v-text-field
                label="Papel*"
                outlined
                dense
                hide-details
                v-model="editedItem.papel"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoTerminals = false"
            >Fechar</v-btn
          >
          <v-btn
            text
            color="success"
            @click="salvarTerminals"
            v-if="editedIndex == -1"
            >Salvar</v-btn
          >
          <v-btn
            text
            color="success"
            @click="editarTerminals"
            v-if="editedIndex != -1"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref="chamaSnackbar" />
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      color="#3BA8A2"
      :is-full-page="fullPage"
    ></loading>
  </v-container>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { baseApiUrl } from "@/global";
import Snackbar from "../componentes/snackbar.vue";
import axios from "axios";
import { mapState } from "vuex";
export default {
  components: { Snackbar, Loading },
  data: () => ({
    isLoading: false,
    fullPage: true,
    lojistas: [],
    tabela: {
      busca: "",
      cabecalho: [
        { text: "Nome", align: "start", value: "nome" },
        { text: "EnderecoMac", value: "enderecoMac" },
        { text: "Tipo", value: "tipo" },
        { text: "Lojista", value: "lojista.nome" },
        { text: "IpImpressora", value: "ipImpressora" },
        { text: "PortaImpressora", value: "portaImpressora" },
        { text: "Orientacao", value: "orientacao" },
        { text: "Papel", value: "papel" },
        { text: "Ativo", value: "ativo" },
        { text: "Ações", value: "action", sortable: false },
      ],
      carregamento: false,
      conteudo: [],
    },
    dialogoTerminals: false,
    editedIndex: -1,
    editedItem: {
      nome: "",
      enderecoMac: "",
      tipo: "",
      empresaId: "",
      lojistaId: "",
      ipImpressora: "",
      portaImpressora: "",
      orientacao: "",
      papel: "",
      ativo: true,
    },
    defaultItem: {
      nome: "",
      enderecoMac: "",
      tipo: "",
      empresaId: "",
      ipImpressora: "",
      portaImpressora: "",
      orientacao: "",
      papel: "",
      ativo: true,
    },
    empresas: [],
    empresaSelecionada: "",
    lojistaSelecionado: "",
  }),

  computed: mapState({
    usuarioLogado: (state) => state.isMenuVisible,
    user: (state) => state.userObj,
    companyobj: (state) => state.companyObj,
    formTitle() {
      return this.editedIndex === -1
        ? "Adicionar novo terminal"
        : "Editar terminal";
    },
  }),

  watch: {
    dialogoTerminals(val) {
      if (val == false) {
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      }
    },
  },

  mounted() {
    if (this.user.tipo == "ADMIN") {
      this.tabela.cabecalho = [
        { text: "Nome", align: "start", value: "nome" },
        { text: "EnderecoMac", value: "enderecoMac" },
        { text: "Tipo", value: "tipo" },
        { text: "Lojista", value: "lojista.nome" },
        { text: "Ativo", value: "ativo" },
        { text: "Ações", value: "action", sortable: false },
      ];
      this.carregaEmpresas();
    } else {
      this.tabela.cabecalho = [
        { text: "Nome", align: "start", value: "nome" },
        { text: "EnderecoMac", value: "enderecoMac" },
        { text: "Tipo", value: "tipo" },
        { text: "Lojista", value: "lojista.nome" },
        { text: "Ativo", value: "ativo" },
        { text: "Ações", value: "action", sortable: false },
      ];
      this.carregaTerminals(this.companyobj.id);
      this.carregaLojistas(this.companyobj.id);
    }
  },

  methods: {
    async carregaEmpresas() {
      await axios
        .get(
          baseApiUrl +
            'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' +
            sessionStorage.getItem("accToken")
        )
        .then((response) => {
          if (response.data.length > 0) {
            this.empresas = response.data;
          }
        });
    },

    async carregaLojistas(empresaId) {
      let url = "";

      if (empresaId) {
        url =
          baseApiUrl +
          'Lojistas?filter={"where":{"empresaId":"' +
          empresaId +
          '"}, "fields":{"nome": true, "id": true}, "order": "nome ASC"}&access_token=' +
          sessionStorage.getItem("accToken");
      } else {
        url =
          baseApiUrl +
          'Lojistas?filter={"where":{"empresaId":"' +
          this.user.empresaId +
          '"}, "order": "nome ASC"}&access_token=' +
          sessionStorage.getItem("accToken");
      }

      await axios.get(url).then((response) => {
        if (response.data) {
          this.lojistas = response.data;
        }
      });
    },

    async carregaTerminals(empresaId) {
      let url = "";
      this.tabela.conteudo = [];
      this.isLoading = true;
      this.tabela.carregamento = true;

      if (empresaId) {
        url =
          baseApiUrl +
          'Terminals?filter={"where":{"and":[{"empresaId":"' +
          empresaId +
          '"}]}, "order":"nome ASC", "include": "lojista"}&access_token=' +
          sessionStorage.getItem("accToken");
      } else {
        url =
          baseApiUrl +
          'Terminals?filter={"where":{"empresaId":"' +
          this.companyobj.id +
          '"}, "order":"nome ASC", "include": "lojista"}&access_token=' +
          sessionStorage.getItem("accToken");
      }

      await axios.get(url).then((response) => {
        if (response.data) {
          this.tabela.conteudo = response.data;
          this.tabela.carregamento = false;
        }
        this.isLoading = false;
      });
    },

    editItem(item) {
      this.isLoading = true;
      this.editedIndex = this.tabela.conteudo.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogoTerminals = true;
      this.isLoading = false;
    },

    async salvarTerminals() {
      var vm = this;
      if (
        this.editedItem.nome ||
        this.editedItem.enderecoMac ||
        this.editedItem.tipo ||
        this.editedItem.ipImpressora ||
        this.editedItem.portaImpressora ||
        this.editedItem.orientacao ||
        this.editedItem.papel ||
        this.editedItem.lojistaId
      ) {
        this.isLoading = true;
        this.editedItem.empresaId =
          this.user.tipo == "ADMIN"
            ? this.empresaSelecionada
            : this.companyobj.id;
        await axios
          .post(
            baseApiUrl +
              "Terminals/replaceOrCreate?access_token=" +
              sessionStorage.getItem("accToken"),
            this.editedItem
          )
          .then((response) => {
            if (response.data) {
              this.isLoading = false;
              this.dialogoTerminals = false;
              vm.$refs.chamaSnackbar.snack(
                "green",
                "Operação realizada com sucesso!",
                "INFORMAÇÃO"
              );
              this.carregaTerminals(
                this.user.tipo == "ADMIN"
                  ? this.empresaSelecionada
                  : this.companyobj.id
              );
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack(
              "red",
              "Erro ao realizar operação",
              "DESCULPE"
            );
          });
      } else {
        vm.$refs.chamaSnackbar.snack(
          "orange",
          "Preencha os campos para prosseguir",
          "ATENÇÃO"
        );
      }
    },

    async editarTerminals() {
      var vm = this;
      if (
        this.editedItem.nome ||
        this.editedItem.enderecoMac ||
        this.editedItem.tipo ||
        this.editedItem.ipImpressora ||
        this.editedItem.portaImpressora ||
        this.editedItem.orientacao ||
        this.editedItem.papel ||
        this.editedItem.lojistaId
      ) {
        this.isLoading = true;
        this.editedItem.empresaId =
          this.user.tipo == "ADMIN"
            ? this.empresaSelecionada
            : this.companyobj.id;
        await axios
          .put(
            baseApiUrl +
              "Terminals/" +
              this.editedItem.id +
              "?access_token=" +
              sessionStorage.getItem("accToken"),
            this.editedItem
          )
          .then((response) => {
            if (response.data) {
              this.isLoading = false;
              this.dialogoTerminals = false;
              vm.$refs.chamaSnackbar.snack(
                "green",
                "Operação realizada com sucesso!",
                "INFORMAÇÃO"
              );
              this.carregaTerminals(
                this.user.tipo == "ADMIN"
                  ? this.empresaSelecionada
                  : this.companyobj.id
              );
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack(
              "red",
              "Erro ao realizar operação",
              "DESCULPE"
            );
          });
      } else {
        vm.$refs.chamaSnackbar.snack(
          "orange",
          "Preencha os campos para prosseguir",
          "ATENÇÃO"
        );
      }
    },

    async deleteItem(item) {
      var r = confirm("Realmente deseja EXCLUIR o terminal " + item.nome + "?");
      if (r == true) {
        await axios
          .delete(
            baseApiUrl +
              "Terminals/" +
              item.id +
              "?access_token=" +
              sessionStorage.getItem("accToken")
          )
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack(
              "success",
              "Operação realizada com sucesso!",
              "INFORMAÇÃO"
            );
            this.carregaTerminals(
              this.user.tipo == "ADMIN"
                ? this.empresaSelecionada
                : this.companyobj.id
            );
          });
      }
    },
  },
};
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #424f4e;
  font-size: 17px;
}

@font-face {
  font-family: Roboto;
  src: url("https://fonts.google.com/specimen/Roboto");
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}

span.v-stepper__step__step.primary {
  background-color: #009b99 !important;
  border-color: #009b9b !important;
}

.theme--light.v-stepper .v-stepper__label {
  color: #009b99;
}

.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
  color: #009b99;
}
</style>
